<!-- Main Content -->
<main class="mainContWrap">      
    <!--slider-->  
    <hp-slider [urlWownet]="urlWownet"></hp-slider>
    <!--category-->
    <hp-categories [urlWownet]="urlWownet"></hp-categories>
    <!--best-->
    <hp-best [urlWownet]="urlWownet" (itemProduct)="getItemOfProduct($event);"></hp-best>
    <!--product-list-->
    <hp-product [urlWownet]="urlWownet"></hp-product>
    <!--brand-->
    <hp-brand [urlWownet]="urlWownet" (itemProduct)="getItemOfProduct($event);"></hp-brand>
    <!--pick-->
    <hp-pick [urlWownet]="urlWownet" (itemProduct)="getItemOfProduct($event);"></hp-pick>
    <!--reviews-->
    <hp-reviews [urlWownet]="urlWownet" (itemProduct)="getItemOfProduct($event);"></hp-reviews>
    <!--promotion-->
    <hp-promotion [urlWownet]="urlWownet"></hp-promotion>
</main>